import { render, staticRenderFns } from "./pickupLogistics.vue?vue&type=template&id=5b806341&scoped=true&"
import script from "./pickupLogistics.js?vue&type=script&lang=js&"
export * from "./pickupLogistics.js?vue&type=script&lang=js&"
import style1 from "./pickupLogistics.vue?vue&type=style&index=1&id=5b806341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b806341",
  null
  
)

export default component.exports